interface UtmParams {
    medium: string | null;
    campaign: string | null;
    source: string | null;
}

export const getUtmlValues = (window: Window): UtmParams => {
    const url = new URL(window.location.href);
    console.log(url.searchParams.get('utm_medium'));
    return {
        medium: url.searchParams.get('utm_medium'),
        campaign: url.searchParams.get('utm_campaign'),
        source: url.searchParams.get('utm_source'),
    };
};
